import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { style: {"float":"right"} }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "m-2" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = { class: "col-md-9" }
const _hoisted_13 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_18 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_19 = { class: "m-2" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = { class: "col-md-9" }
const _hoisted_23 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_29 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_30 = { class: "m-2" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = { class: "col-md-9" }
const _hoisted_34 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_40 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_41 = { class: "m-2" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-md-3" }
const _hoisted_44 = { class: "col-md-9" }
const _hoisted_45 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = { class: "d-flex align-items-center" }
const _hoisted_48 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_49 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_50 = { class: "m-2" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = {
  key: 0,
  class: "col-md-3 d-flex justify-content-start mb-1 mb-md-0"
}
const _hoisted_53 = { class: "col-md-9" }
const _hoisted_54 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = { class: "d-flex align-items-center" }
const _hoisted_57 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_58 = {
  key: 1,
  class: "text-info"
}
const _hoisted_59 = { key: 2 }
const _hoisted_60 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_61 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_62 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_63 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_64 = { key: 7 }
const _hoisted_65 = { class: "dropdown" }
const _hoisted_66 = { class: "dropdown-menu" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { key: 1 }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { key: 2 }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { key: 8 }
const _hoisted_74 = { class: "row" }
const _hoisted_75 = { class: "col-md-6" }
const _hoisted_76 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_77 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_78 = { class: "m-2" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = {
  key: 0,
  cols: "12",
  md: "3",
  class: "d-flex justify-content-start mb-1 mb-md-0"
}
const _hoisted_81 = {
  cols: "12",
  md: "9"
}
const _hoisted_82 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_83 = { class: "form-group" }
const _hoisted_84 = { class: "d-flex align-items-center" }
const _hoisted_85 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_86 = {
  key: 1,
  class: "text-info"
}
const _hoisted_87 = { key: 2 }
const _hoisted_88 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_89 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_90 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_91 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_92 = { key: 7 }
const _hoisted_93 = { class: "row" }
const _hoisted_94 = { class: "col-md-6" }
const _hoisted_95 = {
  class: "modal fade",
  id: "modal_update",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_96 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_97 = { class: "modal-content p-15 p-md-40" }
const _hoisted_98 = { class: "modal-body" }
const _hoisted_99 = {
  class: "modal fade",
  id: "modal_update_price",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_100 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_101 = { class: "modal-content p-15 p-md-40" }
const _hoisted_102 = { class: "modal-body" }
const _hoisted_103 = { class: "mb-3" }
const _hoisted_104 = { class: "modal-footer" }
const _hoisted_105 = {
  class: "modal fade",
  id: "modal_fees_edit",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_106 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_107 = { class: "modal-content p-15 p-md-40" }
const _hoisted_108 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!
  const _component_UpdateParcel = _resolveComponent("UpdateParcel")!
  const _component_UpdateFeesParcel = _resolveComponent("UpdateFeesParcel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.invoice.invoice_ref), 1),
      _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("h5", null, [
        _cache[22] || (_cache[22] = _createTextVNode(" Date de création : ", -1)),
        (_ctx.invoice.created_at)
          ? (_openBlock(), _createElementBlock("b", _hoisted_2, _toDisplayString(_ctx.getDate(_ctx.invoice.created_at)), 1))
          : _createCommentVNode("", true),
        _cache[23] || (_cache[23] = _createTextVNode(" | Store :", -1)),
        (_ctx.invoice.client)
          ? (_openBlock(), _createElementBlock("b", _hoisted_3, _toDisplayString(_ctx.invoice.client.store) + " - (" + _toDisplayString(_ctx.invoice.customer_name) + " )", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.invoice.statut === 0 && _ctx.invoice.parcels_num != 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.auth.can('INV'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    style: {"margin-right":"4px"},
                    class: "btn btn-primary",
                    title: "Enregistrer la facture",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.SaveBon()))
                  }, [
                    _createVNode(_component_feather_icon, { icon: "SaveIcon" })
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.invoice.statut === 1 && _ctx.invoice.parcels_num != 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              style: {"margin-right":"4px"},
              class: "btn btn-warning",
              title: "Ouvrir la facture",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.UnSaveFact()))
            }, [
              _createVNode(_component_feather_icon, { icon: "UnlockIcon" })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.invoice.statut === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "card-header" }, [
                _createElementVNode("h5", null, "Autres frais ( Non Ajoutés )")
              ], -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      (_ctx.invoice.statut === 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            style: {"margin-right":"12px"},
                            class: "btn btn-success",
                            type: "button",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.AddNewFees && _ctx.AddNewFees(...args)))
                          }, " Ajouter "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pgFees.searchTerm) = $event)),
                              placeholder: "Chercher",
                              class: "form-control",
                              type: "text",
                              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSearch(_ctx.getFees)))
                            }, null, 544), [
                              [_vModelText, _ctx.pgFees.searchTerm]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode(_component_vue_good_table, {
                  columns: _ctx.ColsFees,
                  rows: _ctx.ExtraFees,
                  "select-options": {
              selectOnCheckboxOnly: true,
              enabled: true,
              clearSelectionText: 'Annuler',
              selectionText: 'Colis Sélectionés',
              disableSelectInfo: true,
              selectAllByGroup: true,
            },
                  responsive: "",
                  onSelectAll: _ctx.onSelectAllFees,
                  onSelectedRowsChange: _ctx.selectionChangedFees
                }, {
                  emptystate: _withCtx(() => [
                    _createVNode(_component_center, null, {
                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                        _createTextVNode("Aucune entrées correspondants trouvés", -1)
                      ])),
                      _: 1,
                      __: [25]
                    })
                  ]),
                  "table-row": _withCtx((props) => [
                    (props.column.field === 'designation')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("span", null, "Frais " + _toDisplayString(props.row.designation), 1),
                          _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1))
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(props.formattedRow[props.column.field]), 1))
                  ]),
                  _: 1
                }, 8, ["columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
                _createVNode(_component_PaginatorContent, {
                  pagination: _ctx.pgFees,
                  offset: 9,
                  onPaginate: _ctx.getFees
                }, null, 8, ["pagination", "onPaginate"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.invoice.statut === 0 ? 'col-md-6' : 'col-md-12')
      }, [
        _createElementVNode("div", _hoisted_17, [
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", null, "Autres frais ( Ajoutés )")
          ], -1)),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  (_ctx.invoice.statut === 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        style: {"margin-right":"12px"},
                        class: "btn btn-danger",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.RemoveFeesExtra && _ctx.RemoveFeesExtra(...args)))
                      }, " Retirer "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pgFeesIn.searchTerm) = $event)),
                          placeholder: "Chercher",
                          type: "text",
                          class: "form-control",
                          onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSearch(_ctx.getFeesIn)))
                        }, null, 544), [
                          [_vModelText, _ctx.pgFeesIn.searchTerm]
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_vue_good_table, {
              columns: _ctx.ColsFees,
              rows: _ctx.ExtraFeesIn,
              "select-options": {
              selectOnCheckboxOnly: true,
              enabled: true,
              clearSelectionText: 'Annuler',
              selectionText: 'Colis Sélectionés',
              disableSelectInfo: true,
              selectAllByGroup: true,
            },
              responsive: "",
              "style-": "table table-hover table-bordered",
              onSelectAll: _ctx.onSelectRemoveFees,
              onSelectedRowsChange: _ctx.selectionChangedNewFees
            }, {
              emptystate: _withCtx(() => [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                    _createTextVNode("Aucune entrées correspondants trouvés", -1)
                  ])),
                  _: 1,
                  __: [28]
                })
              ]),
              "table-row": _withCtx((props) => [
                (props.column.field === 'designation')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", null, "Frais " + _toDisplayString(props.row.designation), 1),
                      _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1))
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
            _createVNode(_component_PaginatorContent, {
              pagination: _ctx.pgFeesIn,
              offset: 9,
              onPaginate: _ctx.getFeesIn
            }, null, 8, ["pagination", "onPaginate"])
          ])
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        (_ctx.invoice.statut === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _cache[33] || (_cache[33] = _createElementVNode("div", { class: "card-header" }, [
                _createElementVNode("h5", null, "Factures ( Non Ajouteés )")
              ], -1)),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      (_ctx.invoice.statut === 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            style: {"margin-right":"12px"},
                            class: "btn btn-success",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.AddNewInvcs && _ctx.AddNewInvcs(...args)))
                          }, " Ajouter "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pgInvs.searchTerm) = $event)),
                              placeholder: "Chercher",
                              type: "text",
                              class: "form-control",
                              onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onSearch(_ctx.getInvs)))
                            }, null, 544), [
                              [_vModelText, _ctx.pgInvs.searchTerm]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode(_component_vue_good_table, {
                  columns: _ctx.InvsFees,
                  rows: _ctx.LessExtraInv,
                  "select-options": {
              selectOnCheckboxOnly: true,
              enabled: true,
              clearSelectionText: 'Annuler',
              selectionText: 'Colis Sélectionés',
              disableSelectInfo: true,
              selectAllByGroup: true,
            },
                  responsive: "",
                  onSelectAll: _ctx.onSelectAllInvcs,
                  onSelectedRowsChange: _ctx.selectionChangedInvcs
                }, {
                  emptystate: _withCtx(() => [
                    _createVNode(_component_center, null, {
                      default: _withCtx(() => _cache[31] || (_cache[31] = [
                        _createTextVNode("Aucune entrées correspondants trouvés", -1)
                      ])),
                      _: 1,
                      __: [31]
                    })
                  ]),
                  "table-row": _withCtx((props) => [
                    (props.column.field === 'total_to_send')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("span", null, _toDisplayString(props.row.total_to_send) + " " + _toDisplayString(_ctx.$devis), 1),
                          _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1))
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(props.formattedRow[props.column.field]), 1))
                  ]),
                  _: 1
                }, 8, ["columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
                _createVNode(_component_PaginatorContent, {
                  pagination: _ctx.pgInvs,
                  offset: 9,
                  onPaginate: _ctx.getInvs
                }, null, 8, ["pagination", "onPaginate"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_38, [
        (_ctx.invoice.statut === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _cache[36] || (_cache[36] = _createElementVNode("div", { class: "card-header" }, [
                _createElementVNode("h5", null, "Factures ( Ajouteés )")
              ], -1)),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      (_ctx.invoice.statut === 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            style: {"margin-right":"12px"},
                            class: "btn btn-danger",
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.RemoveNewInvcs && _ctx.RemoveNewInvcs(...args)))
                          }, " Retirer "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.pgInvsIn.searchTerm) = $event)),
                              placeholder: "Chercher",
                              type: "text",
                              class: "form-control",
                              onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onSearch(_ctx.getInvsIn)))
                            }, null, 544), [
                              [_vModelText, _ctx.pgInvsIn.searchTerm]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode(_component_vue_good_table, {
                  columns: _ctx.InvsFees,
                  rows: _ctx.LessExtraInvIn,
                  "select-options": {
              selectOnCheckboxOnly: true,
              enabled: true,
              clearSelectionText: 'Annuler',
              selectionText: 'Colis Sélectionés',
              disableSelectInfo: true,
              selectAllByGroup: true,
            },
                  responsive: "",
                  onSelectAll: _ctx.onSelectRemoveInvcs,
                  onSelectedRowsChange: _ctx.selectionChangedNewInvcs
                }, {
                  emptystate: _withCtx(() => [
                    _createVNode(_component_center, null, {
                      default: _withCtx(() => _cache[34] || (_cache[34] = [
                        _createTextVNode("Aucune entrées correspondants trouvés", -1)
                      ])),
                      _: 1,
                      __: [34]
                    })
                  ]),
                  "table-row": _withCtx((props) => [
                    (props.column.field === 'total_to_send')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("span", null, _toDisplayString(props.row.total_to_send) + " " + _toDisplayString(_ctx.$devis), 1),
                          _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1))
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
                _createVNode(_component_PaginatorContent, {
                  pagination: _ctx.pgInvsIn,
                  offset: 9,
                  onPaginate: _ctx.getInvsIn
                }, null, 8, ["pagination", "onPaginate"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.invoice.statut === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _cache[45] || (_cache[45] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", null, "Liste des nouveaux colis")
          ], -1)),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                (_ctx.auth.can('ADD_INV'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      (_ctx.invoice.statut === 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            style: {"margin-right":"12px"},
                            class: "btn btn-success",
                            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.AddNewColis && _ctx.AddNewColis(...args)))
                          }, " Ajouter "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.users1.searchTerm) = $event)),
                          placeholder: "Chercher",
                          type: "text",
                          class: "form-control",
                          onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.getRows1()))
                        }, null, 544), [
                          [_vModelText, _ctx.users1.searchTerm]
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columns,
              rows: _ctx.rows1,
              "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        },
              responsive: "",
              onSelectAll: _ctx.onSelectAll,
              onSelectedRowsChange: _ctx.selectionChanged
            }, {
              emptystate: _withCtx(() => [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[37] || (_cache[37] = [
                    _createTextVNode("Aucune entrées correspondants trouvés", -1)
                  ])),
                  _: 1,
                  __: [37]
                })
              ]),
              "table-row": _withCtx((props) => [
                (props.column.field === 'code')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (props.row.replace === 1)
                        ? (_openBlock(), _createElementBlock("h6", _hoisted_57, [
                            _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                            _cache[38] || (_cache[38] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                          ]))
                        : (props.row.partial === 1)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_58, [
                              _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                              _cache[39] || (_cache[39] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                            ]))
                          : (_openBlock(), _createElementBlock("h6", _hoisted_59, _toDisplayString(props.row.code), 1))
                    ], 64))
                  : (props.column.field === 'status')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                              style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(props.row.status_second)
                  .code_color,
              })
                            }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                              style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                            }, _toDisplayString(props.row.s_name), 5))
                      ], 64))
                    : (props.column.field === 'price')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("b", null, _toDisplayString(props.row.price), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                        ], 64))
                      : (props.column.field === 'delivery_time')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            (props.row.delivery_time)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.getDate(props.row.delivery_time)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_61))
                          ], 64))
                        : (props.column.field === 'pickup_time')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              (props.row.pickup_time)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.getDate(props.row.pickup_time)), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_63))
                            ], 64))
                          : (props.column.field === 'fees')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                (
                props.row.status === 'DELIVERED' ||
                props.row.status === 'DELIVERED_PARTIAL'
              )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("b", null, _toDisplayString(props.row.delivered_fees), 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                    ], 64))
                                  : (
                props.row.partial === 1 && props.row.status === 'RETURNED'
              )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("b", null, _toDisplayString(props.row.delivered_fees), 1),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                      ], 64))
                                    : (
                props.row.replace === 1 &&
                (props.row.status === 'RETURNED' ||
                  props.row.status === 'DELIVERED')
              )
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          _createElementVNode("b", null, _toDisplayString(props.row.delivered_fees), 1),
                                          _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                        ], 64))
                                      : (
                props.row.status != 'DELIVERED' &&
                (props.row.status === 'IN_PROGRESS' ||
                  (props.row.status === 'RETURNED' &&
                    props.row.partial == 0 &&
                    props.row.replace == 0)) &&
                props.row.status_second &&
                props.row.status_second === 'REFUSE'
              )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                            _createElementVNode("b", null, _toDisplayString(props.row.refused_fees), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                          ], 64))
                                        : _createCommentVNode("", true)
                              ], 64))
                            : (props.column.field === 'total')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                  (
                props.row.status === 'DELIVERED' ||
                props.row.status === 'DELIVERED_PARTIAL'
              )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("b", null, _toDisplayString(props.row.price - props.row.delivered_fees), 1),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                      ], 64))
                                    : (
                props.row.partial === 1 && props.row.status === 'RETURNED'
              )
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createElementVNode("b", null, _toDisplayString(props.row.price - props.row.delivered_fees), 1),
                                          _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                        ], 64))
                                      : (
                props.row.replace === 1 &&
                (props.row.status === 'RETURNED' ||
                  props.row.status === 'DELIVERED')
              )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            _createElementVNode("b", null, _toDisplayString(props.row.price - props.row.delivered_fees), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                          ], 64))
                                        : (
                props.row.status != 'DELIVERED' &&
                (props.row.status === 'IN_PROGRESS' ||
                  (props.row.status === 'RETURNED' &&
                    props.row.partial == 0 &&
                    props.row.replace == 0)) &&
                props.row.status_second &&
                props.row.status_second === 'REFUSE'
              )
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                              _createElementVNode("b", null, _toDisplayString(0 - props.row.refused_fees), 1),
                                              _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                ], 64))
                              : (props.column.field === 'action')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_64, [
                                    _createElementVNode("div", _hoisted_65, [
                                      _cache[43] || (_cache[43] = _createElementVNode("button", {
                                        class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                                        type: "button",
                                        "data-bs-toggle": "dropdown",
                                        "aria-expanded": "false"
                                      }, [
                                        _createElementVNode("i", { class: "flaticon-dots" })
                                      ], -1)),
                                      _createElementVNode("ul", _hoisted_66, [
                                        (
                    _ctx.invoice.statut === 0 &&
                    props.row.status != 'INVOICED' &&
                    props.row.invoiced === 0
                  )
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_67, [
                                              _createElementVNode("a", {
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.showUpdate(props.row))
                                              }, _cache[40] || (_cache[40] = [
                                                _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Modifier Colis ", -1)
                                              ]), 8, _hoisted_68)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (
                    _ctx.auth.can('PARCELS') &&
                    _ctx.auth.can('EDIT_PRICE_PARCELS') &&
                    props.row.situation != 'Facturé' &&
                    props.row.situation != 'INVOICED' &&
                    props.row.invoiced != 1
                  )
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_69, [
                                              _createElementVNode("a", {
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.openPriceModal(props.row))
                                              }, _cache[41] || (_cache[41] = [
                                                _createElementVNode("i", { class: "flaticon-money lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Modifier Prix ", -1)
                                              ]), 8, _hoisted_70)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (
                    _ctx.auth.can('PARCELS') &&
                    _ctx.auth.can('EDIT_FEES_PARCELS') &&
                    (_ctx.user.role_id === 1 || _ctx.user.role_id === 2) &&
                    props.row.status !== 'NEW_PARCEL' &&
                    props.row.status !== 'WAITING_PICKUP' &&
                    props.row.invoiced === 0
                  )
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_71, [
                                              _createElementVNode("a", {
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.handleFeesClick(props.row))
                                              }, _cache[42] || (_cache[42] = [
                                                _createElementVNode("i", { class: "flaticon-invoice lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Modifier Frais ", -1)
                                              ]), 8, _hoisted_72)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
            _createElementVNode("div", _hoisted_74, [
              _cache[44] || (_cache[44] = _createElementVNode("div", { class: "col-md-6" }, null, -1)),
              _createElementVNode("div", _hoisted_75, [
                _createVNode(_component_PaginatorContent, {
                  pagination: _ctx.users1,
                  offset: 9,
                  onPaginate: _ctx.getRows1
                }, null, 8, ["pagination", "onPaginate"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_76, [
      _cache[50] || (_cache[50] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", null, "Liste des colis ajoutés")
      ], -1)),
      _createElementVNode("div", _hoisted_77, [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            (_ctx.auth.can('ADD_INV'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                  (_ctx.invoice.statut === 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        style: {"margin-right":"12px"},
                        class: "btn btn-danger",
                        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.RemoveNewColis && _ctx.RemoveNewColis(...args)))
                      }, " Supprimer "))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.users2.searchTerm) = $event)),
                      placeholder: "Chercher",
                      type: "text",
                      class: "form-control",
                      onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.getRows2()))
                    }, null, 544), [
                      [_vModelText, _ctx.users2.searchTerm]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows2,
          "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        },
          responsive: "",
          onSelectAll: _ctx.onSelectAllColis,
          onSelectedRowsChange: _ctx.selectionChangedColis
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[46] || (_cache[46] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [46]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace === 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_85, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[47] || (_cache[47] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                      ]))
                    : (props.row.partial === 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_86, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[48] || (_cache[48] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_87, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
                (props.row.status === 'IN_PROGRESS' ||
                  (props.row.status === 'RETURNED' &&
                    props.row.partial == 0 &&
                    props.row.replace == 0)) &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(props.row.status_second)
                  .code_color,
              })
                        }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                      : (
                props.row.partial === 1 && props.row.status === 'RETURNED'
              )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                            style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper('DELIVERED').code_color,
              })
                          }, " Livré partiel ", 4))
                        : (
                props.row.replace === 1 &&
                (props.row.status === 'RETURNED' ||
                  props.row.status === 'DELIVERED')
              )
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                              style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper('DELIVERED').code_color,
              })
                            }, " Livré change ", 4))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 3,
                              class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                              style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                            }, _toDisplayString(props.row.s_name), 5))
                  ], 64))
                : (props.column.field === 'price')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("b", null, _toDisplayString(props.row.price), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                    ], 64))
                  : (props.column.field === 'delivery_time')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (props.row.delivery_time)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(_ctx.getDate(props.row.delivery_time)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_89))
                      ], 64))
                    : (props.column.field === 'pickup_time')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          (props.row.pickup_time)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString(_ctx.getDate(props.row.pickup_time)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_91))
                        ], 64))
                      : (props.column.field === 'fees')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                            (
                props.row.status_colis === 'DELIVERED' ||
                props.row.status_colis === 'DELIVERED_PARTIAL'
              )
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("b", null, _toDisplayString(props.row.delivered_fees), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                ], 64))
                              : _createCommentVNode("", true),
                            (
                props.row.status_colis != 'DELIVERED' &&
                (props.row.status_colis === 'RETURNED' ||
                  props.row.status_colis === 'REFUSE')
              )
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("b", null, _toDisplayString(props.row.refused_fees), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (props.column.field === 'total')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                              (
                props.row.status_colis === 'DELIVERED' ||
                props.row.status_colis === 'DELIVERED_PARTIAL'
              )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("b", null, _toDisplayString(props.row.price - props.row.delivered_fees), 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (
                props.row.status_colis != 'DELIVERED' &&
                (props.row.status_colis === 'RETURNED' ||
                  props.row.status_colis === 'REFUSE')
              )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("b", null, _toDisplayString(0 - props.row.refused_fees), 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
        _createElementVNode("div", _hoisted_93, [
          _cache[49] || (_cache[49] = _createElementVNode("div", { class: "col-md-6" }, null, -1)),
          _createElementVNode("div", _hoisted_94, [
            _createVNode(_component_PaginatorContent, {
              pagination: _ctx.users2,
              offset: 9,
              onPaginate: _ctx.getRows2
            }, null, 8, ["pagination", "onPaginate"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_95, [
      _createElementVNode("div", _hoisted_96, [
        _createElementVNode("div", _hoisted_97, [
          _cache[51] || (_cache[51] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Modifier Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_98, [
            (_ctx.rowUpdate)
              ? (_openBlock(), _createBlock(_component_UpdateParcel, {
                  key: 0,
                  rowColis: _ctx.rowUpdate,
                  getRecords: _ctx.getRows1,
                  isOpenEdit: _ctx.isOpenEdit,
                  hideModal: _ctx.hideModal
                }, null, 8, ["rowColis", "getRecords", "isOpenEdit", "hideModal"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_99, [
      _createElementVNode("div", _hoisted_100, [
        _createElementVNode("div", _hoisted_101, [
          _cache[54] || (_cache[54] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Modification du prix de colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_102, [
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_103, [
                _cache[52] || (_cache[52] = _createElementVNode("label", {
                  for: "price",
                  class: "form-label"
                }, "Prix", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "price",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.PriceColis.price) = $event)),
                  type: "number",
                  class: "form-control",
                  placeholder: "Prix du colis"
                }, null, 512), [
                  [_vModelText, _ctx.PriceColis.price]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_104, [
            _cache[53] || (_cache[53] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Annuler ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.EditPriceColis && _ctx.EditPriceColis(...args)))
            }, " Enregistrer ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_105, [
      _createElementVNode("div", _hoisted_106, [
        _createElementVNode("div", _hoisted_107, [
          _cache[55] || (_cache[55] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Modifier les frais"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_108, [
            (_ctx.rowUpdateFees)
              ? (_openBlock(), _createBlock(_component_UpdateFeesParcel, {
                  key: 0,
                  rowColis: _ctx.rowUpdateFees,
                  getRecords: _ctx.getRows1,
                  isOpenFees: _ctx.isOpenFees,
                  hideModal: _ctx.hideModal
                }, null, 8, ["rowColis", "getRecords", "isOpenFees", "hideModal"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}